module.exports = __webpack_public_path__ + "img/paypal-icon.aed46e9.jpg";